import { useDispatch, useSelector } from "react-redux";

import { set_song } from "../../../../../actions/song";
import { update_current_album_and_song } from "../../../../../actions/currentalbum";
import { setIsPlaying } from "../../../../../actions/isplaying.js";

const Song = ({ album_index, song, song_index }) =>
{

  const dispatch = useDispatch();

  const all_albums = useSelector((state) => state.albums);

  const handle_click = (song) =>
  {
    dispatch(update_current_album_and_song(all_albums, album_index, song_index));
    dispatch(set_song(song));
    dispatch(setIsPlaying(true));
  }

  return (
    <div className={"songDiv"} onClick={() => handle_click(song)}>{song.title}</div>
  );
}

export default Song;
